module.exports = {
  lang: {
    t1: "الصفحة الرئيسية",
    t2: "بطاقة العمل",
    t3: "متابعة",
    t4: "جهات الاتصال",
    t5: "رسائل",
    t6: "دخول",
    t7: "التسجيل",
    t8: "منصة جديدة لاتصالات الأعمال العالمية. منطقة جديدة للتسويق الرقمي للمؤسسات.",
    t9: "WeMeet تسجيل الدخول برقم الهاتف المحمول",
    t10: "رقم الهاتف المحمول",
    t11: "رمز التحقق",
    t12: "إدخال رقم الهاتف المحمول",
    t13: "إدخال رمز التحقق",
    t14: "الحصول",
    t15: "الدخول",
    t16: "إدخال التنسيق الصحيح لرقم الهاتف المحمول",
    t17: "تم ارسال رمز التأكيد",
    t18: "تم إدخال رمز التحقق غير صحيح. يرجى التحقق وإعادة الإدخال",
    t19: "تم تسجيل الدخول بنجاح",
    t20: "رمز التحقق الخاص بك هو (0). يرجى استخدامه في غضون {1} دقيقة(ات).",
    t21: "إلغاء",
    t22: "تأكيد",
    t23: "نصائح الدافئة",
    t24: "تسجيل حساب WeMeet الخاص بك لم يتم الانتهاء منه بعد. اتخذ إجراءً الآن لإكمال عملية التسجيل والاستمتاع بالتفاعل المتنوع والاحتمالات اللانهائية.",
    t25: "اذهب للتسجيل",
    t26: "تسجيل الدخول عبر البريد الإلكتروني ص WeMeet",
    t27: "اسم الحساب",
    t28: "أدخل عنوان بريدك الإلكتروني",
    t29: "كلمة المرور",
    t30: "ادخل رقمك السري",
    t31: "نسيت كلمة المرور؟",
    t32: "تسجيل الدخول",
    t33: "طرق تسجيل الدخول الأخرى",
    t34: "تم التسجيل في تطبيق WeMeet المصغر؟ استخدمه",
    t35: "تسجيل الدخول باستخدام رقم الهاتف المحمول",
    t36: "إدخال البريد الإلكتروني الخاص بك أولا",
    t37: "إدخال كلمة المرور الخاصة بك أولا",
    t38: "تنسيق عنوان البريد الإلكتروني غير صحيح",
    t39: "فيمكنك تسجيل الدخول مباشرة WeMeetإذا كان لديك بحساب",
    t40: "تسجيل الدخول",
    t41: "الصورة الشخصيه",
    t42: "تحميل صورة الملف الشخصي الحقيقية",
    t43: "الاسم الكامل",
    t44: "إدخال اسمك الأول",
    t45: "إدخال اسمك الأخير",
    t46: "اسم المؤسسة",
    t47: "ادخال اسم مؤسستكم",
    t48: "المنصب",
    t49: "ادخال عنوان منصبك في هذه المؤسسة",
    t50: "بريد إلكتروني",
    t51: "إدخال البريد الإلكتروني الخاص بك أولا",
    t52: "رقم الهاتف المحمول",
    t53: "إدخال رقم الهاتف المحمول",
    t54: "منطقة",
    t55: "اختيار منطقة",
    t56: "منطقة",
    t57: "اختيار المحافظة والمنطقة والحي",
    t58: "عنوان",
    t59: "ادخال عنوانك",
    t60: "WeMeetقرأت وأوافق على شروط الخدمة وسياسة الخصوصية لـ",
    t61: "شروط الخدمة",
    t62: "سياسة الخصوصية",
    t63: "تابع",
    t64: "يرجى التحقق من اتفاقية المستخدم أولا",
    t65: "إدخال اسمك الأول",
    t66: "إدخال اسمك الأخير",
    t67: "إدخال البريد الإلكتروني الخاص بك أولا",
    t68: "ادخال اسم مؤسستكم",
    t69: "تنسيق عنوان البريد الإلكتروني غير صحيح",
    t70: "إلغاء",
    t71: "اكتمال",
    t72: "التحقق من رقم الهاتف المحمول",
    t73: "رقم الهاتف المحمول",
    t74: "رمز التحقق",
    t75: "إدخال رمز التحقق",
    t76: "الحصول",
    t77: "تخطي التحقق",
    t78: "التقديم",
    t79: "تم التحقق",
    t80: "تم إدخال رمز التحقق غير صحيح. يرجى التحقق وإعادة الإدخال",
    t81: "تم تخطيه",
    t82: "نصائح الدافئة",
    t83: "لا حاجة للتسجيل مرة أخرى. WeMeet رقم الهاتف الذي أدخلته مسجل بالفعل في حساب",
    t84: "اذهب للتسجيل الدخول",
    t85: "نصائح الدافئة",
    t86: "لا حاجة للتسجيل مرة أخرى. WeMeet البريد الإلكتروني الذي أدخلته مسجل بالفعل في حساب",
    t87: "اذهب للتسجيل الدخول",
    t88: "تم إرسال رابط التحقق",
    t89: "التحقق من بريدك الإلكتروني والنقر على الرابط لإكمال التسجيل",
    t90: "فهمت",
    t91: "WeMeet مرحبا بك في",
    t92: "مرحبًا بك في WeMeet، يرجى النقر على الزر لإكمال التسجيل. تذكير ودي: هذا الرابط صالح لمدة 24 ساعة فقط، يرجى إكمال العملية في أقرب وقت ممكن.",
    t93: "سجل الآن",
    t94: "لقد تم تفعيل البريد الإلكتروني الخاص بك. من فضلك أدخل رقمك السري.",
    t95: "إدخال كلمة المرور الخاصة بك",
    t96: "إدخال كلمة المرور الخاصة بك",
    t97: "تأكيد كلمة المرور",
    t98: "إدخال كلمة المرور مرة أخرى",
    t99: "يجب أن يحتوي على مجموعة من الأحرف الكبيرة والصغيرة والأرقام والأحرف الخاصة، بطول يتراوح بين 8 و20 حرفًا",
    t100: "أدخل كلمة المرور الخاصة بك",
    t101: "يرجى إدخال كلمة المرور مرة أخرى",
    t102: "كلمات المرور غير متطابقة",
    t103: "مبروك إكمال تسجيلك",
    t104: "WeMeet لقد قمت بتسجيل الدخول إلى",
    t105: "استمر في تجربتك",
    t106: "نصائح الدافئة",
    t107: "WeMeet لقد قمت بتسجيل الدخول إلى",
    t108: "إعادة إرسال",
    t109: "شروط الخدمة",
    t110: "سياسة الخصوصية",
    t111: "استعادة كلمة المرور",
    t112: "تحديد الحساب الذي ترغب في استعادة كلمة المرور الخاصة به",
    t113: "اسم الحساب",
    t114: "إدخال البريد الإلكتروني الخاص بك",
    t115: "التقديم",
    t116: "إدخال البريد الإلكتروني الخاص بك أولا",
    t117: "تنسيق عنوان البريد الإلكتروني غير صحيح",
    t118: "تم إرسال البريد الإلكتروني",
    t119: "التحقق من بريدك الإلكتروني، والنقر على الرابط، وإعادة تعيين كلمة المرور الخاصة بك",
    t120: "فهمت",
    t121: "WeMeet-إعادة تعيين كلمة المرور",
    t122: "لقد تم تأكيد طلب إعادة تعيين كلمة المرور الخاصة بك وتم إنشاء رابط مؤقت لإعادة تعيين كلمة المرور. تذكير دافئ: هذا الرابط صالح لمدة 24 ساعة، يرجى تشغيله في أقرب وقت ممكن.",
    t123: "إعادة تعيين كلمة المرور",
    t124: "إعادة تعيين كلمة المرور بنجاح",
    t125: "لقد تم تسجيل دخولك مرحبا بك من جديد.",
    t126: "الذهاب إلى الصفحة الرئيسية",
    t127: "جهات الاتصال",
    t128: "طلب اتصال جديد",
    t129: "الموافقة",
    t130: "تجاهل",
    t131: "موافق عليه",
    t132: "تمت إغفاله",
    t133: "أنا متابع",
    t134: "متابع",
    t135: "رسائل",
    t136: "لم تتم معالجة الطلب",
    t137: "إدخار اسمك او رقم الهاتف",
    t138: "لم يتم العثور على محتوى مطابق",
    t139: "لا يوجد المزيد",
    t140: "طلب اتصال",
    t141: "الموافقة",
    t142: "تجاهل",
    t143: "موافق عليه",
    t144: "تمت إغفاله",
    t145: "مساحة الذكاء الاصطناعي",
    t146: "متابع",
    t147: "غير متابع",
    t148: "vCard",
    t149: "إضافة جهة اتصال",
    t150: "إرسال رسالة",
    t151: "في انتظار الموافقة",
    t152: "إزالة جهة اتصال",
    t153: "المقدمة الشخصية",
    t154: "ابملف الشخصي",
    t155: "نصائح الدافئة",
    t156: "تم إرسال طلب الاتصال الخاص بك بمجرد الموافقة عليه، وسوف تقوم بمتابعته تلقائيًا. يمكنك أيضًا متابعته أولاً لمعرفة المزيد",
    t157: "لا تتبع الآن",
    t158: "متابعة",
    t159: "متابع",
    t160: "إلغاء علاقة جهة اتصال",
    t161: "بعد قيامك بإلغاء علاقة الاتصال، لن يتمكن الطرف الآخر من الاطلاع على معلوماتك الشخصية، لكنه لن يقوم بإلغاء متابعتك في نفس الوقت.",
    t162: "فكر مرة أخرى",
    t163: "إزالة جهة اتصال",
    t164: "عملية ناجحة",
    t165: "مساعد AI WeMeet",
    t166: "إدخال سؤالك",
    t167: "إرسال",
    t168: "لاحظ أن محتوى تفاعل الذكاء الاصطناعي قد يكون غير دقيق ولا يمثل وجهة نظر النظام الأساسي",
    t169: "WeMeet بطاقة العمل",
    t170: "تحميل",
    t171: "تعديل بطاقة العمل",
    t172: "تحميل رمز الاستجابة السريعة",
    t173: "تم إنشاء الصورة. يرجى حفظه. مسح رمز الاستجابة السريعة",
    t174: "صورة الملف الشخصي",
    t175: "يرجى تحميل صورة الملف الشخصي الحقيقية",
    t176: "الاسم الكامل",
    t177: "إدخال اسمك الأول",
    t178: "إدخال اسمك الأخير",
    t179: "إدخار اسمك",
    t180: "اسم المؤسسة",
    t181: "ادخال اسم مؤسستكم",
    t182: "المنصب",
    t183: "ادخال عنوان منصبك في هذه المؤسسة",
    t184: "بريد إلكتروني",
    t185: "إدخال البريد الإلكتروني الخاص بك",
    t186: "رقم الهاتف المحمول",
    t187: "إدخال رقم الهاتف المحمول",
    t188: "منطقة",
    t189: "اختيار منطقة",
    t190: "منطقة",
    t191: "اختيار المحافظة والمنطقة والحي",
    t192: "عنوان",
    t193: "ادخال عنوانك",
    t194: "إدخال اسمك الأول",
    t195: "إدخال اسمك الأخير",
    t196: "إدخال البريد الإلكتروني الخاص بك",
    t197: "ادخال اسم مؤسستكم",
    t198: "تنسيق عنوان البريد الإلكتروني غير صحيح",
    t199: "غرفة دردشة",
    t200: "معرض الصور",
    t201: "التصوير",
    t202: "إدخال رسالة",
    t203: "إرسال",
    t204: "قرأت",
    t205: "لم أقرأ",
    t206: "أذكر انتهاء المهلة الزمنية",
    t207: "إلغاء",
    t208: "صورة",
    t209: "ألبوم",
    t210: "التصوير",
    t211: "اختيار من الألبوم",
    t212: "إلغاء",
    t213: "صورة",
    t214: "صورة شخصية",
    t215: "المعاينة",
    t216: "اكتمال",
    t217: "WeMeet مساحة الذكاء الاصطناعي",
    t218: "تواصل معنا",
    t219: "اتصل بي",
    t220: "الاسم الكامل",
    t221: "منظمة",
    t222: "منصب",
    t223: "هاتف",
    t224: "بريد إلكتروني",
    t225: "منطقة",
    t226: "منطقة",
    t227: "عنوان",
    t228: "إدخار اسمك",
    t229: "ادخال اسم مؤسستكم",
    t230: "إدخال منصبك",
    t231: "إدخال رقم هاتفك",
    t232: "إدخال البريد الإلكتروني الخاص بك",
    t233: "اختيار منطقة",
    t234: "اختيار المحافظة والمنطقة والحي",
    t235: "ادخال عنوانك",
    t236: "نية",
    t237: "شراء المنتجات",
    t238: "منتجات الوكيل",
    t239: "تعاون السوق",
    t240: "آخر",
    t241: "إدخار اسمك",
    t242: "ادخال اسم مؤسستكم",
    t243: "إدخال البريد الإلكتروني الخاص بك",
    t244: "إدخال البريد الإلكتروني الخاص بك",
    t245: "تم إرسال الرسالة",
    t246: "ترك رسالة",
    t247: "إدخال محتوى استفسارك",
    t248: "تأكيد",
    t249: "تسجيل الدخول أو التسجيل أولاً",
    t250: "المتابعين",
    t251: "تواصل معنا",
    t252: "منتجات",
    t253: "فريق",
    t254: "نظرة عامة",
    t255: "ألبوم",
    t256: "تأهيل",
    t257: "رأس المال المسجل",
    t258: "تاريخ التأسيس",
    t259: "العنوان المسجل",
    t260: "المنبع",
    t261: "منتتصف الطريق",
    t262: "المصب",
    t263: "ملحق",
    t264: "عملية",
    t265: "المصب",
    t266: "ملحق",
    t267: "عملية",
    t268: "الإنجليزية",
    t269: "الفرنسية",
    t270: "الروسية",
    t271: "الإسبانية",
    t272: "اليابانية",
    t273: "الكورية",
    t274: "الإندونيسية",
    t275: "الفيتنامية",
    t276: "الألمانية",
    t277: "التركية",
    t278: "الإيطالية",
    t279: "البرتغالية",
    t280: "التايلاندية",
    t281: "الملايو",
    t282: "العربية",
    t283: "اسم المستخدم أو كلمة المرور غير صحيحين",
    t284: "يرجى قراءة وقبول اتفاقية مستخدمي WeMeet أولاً",
    t285: "لا يوجد محتوى ذي صلة",
    t286: "نوع",
    t287: "صفة",
    t288: "تفاصيل",
    t289: "آخر",
    t290: "إجمالي 2",
    t291: "{1} يدعوك لزيارة WeMeet AI Space لـ {2}",
    t292: "انقر هنا لعرض مثال أو إدخال سؤال:",
    t293: "تحديث",
    t294: "يمكنك أيضًا النقر على بطاقة العمل أدناه لإضافة جهات اتصال لمزيد من المعلومات:",
    t295: "تعلم",
    t296: "اجتماعات WeMeet الرقمية",
    t297: "معارض WeMeet الرقمية",
    t298: "Kad nama dan Ruang WeMeet AI",
    t299: "كيف تصبح عضوًا في منظمة WeMeet",
    t300: "يوفر WeMeet خدمة المؤتمرات الرقمية لك بحل شامل للاجتماعات عبر الإنترنت، بما في ذلك ولكن لا يقتصر على إنشاء ونشر الاجتماعات، إدارة تسجيل المشاركين، التسجيل الإلكتروني، جدولة الاجتماعات، مشاركة مواد الاجتماع، مناقشات تفاعلية في الوقت الحقيقي، وتفاعل الضيوف.",
    t301: 'WeMeet المعرض الرقمي ، الذي يساعد على بناء موقع ويب رسمي مصغر للمعرض بسرعة. عرض معلومات المعارضين ، وإعلانات المعروضات ، وبث مباشر للمعرض ، وتسجيل المعرض ، وجدول الفعاليات ، والمزيد ، مما يتيح للشركات المشاركة والجمهور فهم تفاصيل المعرض بسهولة. لاستخدام ميزة WeMeet المعرض الرقمي ، يرجى إكمال عملية الدخول المؤسسي أولاً. انقر على "أنا" ، اسحب الصفحة إلى "مركز الخدمة" - "الدخول المؤسسي" واتبع التعليمات لإكمال عملية الدخول.',
    t302: "مستخدمو WeMeet الشخصيون يحتاجون فقط إلى تفويض هويتهم على WeChat ورقم هاتفهم وإكمال التسجيل في المنصة للحصول على بطاقة أعمال رقمية شخصية والحفاظ على صالون AI الشخصي الخاص بهم (بما في ذلك السيرة الذاتية الشخصية، التحديثات، الصور، الوثائق، إلخ).",
    t303: 'انقر فوق الخيار "أنا" في شريط القائمة السفلي للبرنامج الصغير لتحديث صفحة بطاقة الأعمال الشخصية وتحسين الصفحة الرئيسية الشخصية.',
    t304: "مزيج من الأحرف الكبيرة والصغيرة والأرقام وعلامات الترقيم، بطول يتراوح بين 8-20 حرفًا.",
    t305: "أدخل اسم المنتج",
    t306: "لا يوجد المزيد",
    t307: "انقر في الزاوية اليمنى العليا",
    t308: "اختر الطريقة التي تفضلها للمشاركة",
    t309: "فهمت",
    t310: "يرجى إكمال التسجيل وتسجيل الدخول أولاً",
    t311: "تعرف على المزيد",
    t312: "المنتجات ذات الصلة",
    t313: "شكرًا لزيارتكم",
    t314: "تسجيل الخروج",
    t315: "المؤسسات التي تمت متابعتها",
    t316: "السابق",
    t317: "التالي",
    t318: "لا يوجد",
    t319: "{1} يدعوك لزيارة {2}",
    t320: "لم يقم صالون AI بصيانة اللغة الحالية",
    t321: "تم التبديل في صالون AI إلى اللغة الحالية",
    t322: "تم تنشيط الرابط",
    t323: "الشبكة مشغولة، يرجى المحاولة مرة أخرى في وقت لاحق",
    t324: "تم تبديل تفاصيل المنتج إلى اللغة الحالية",
    t325: "تفاصيل المنتج غير محافظة حاليًا في هذه اللغة",
    t326: "مرحبًا، أنا مساعد WeMeet الذكي للذكاء الاصطناعي، على استعداد لتقديم خدمة متفانية في أي وقت! كيف يمكنني مساعدتك؟",
    t327: "أدخل الاسم",
    t328: "لقد وجدت معلومات جهة الاتصال ذات الصلة ، يرجى التحقق من بطاقة الاتصال أدناه.",
    t329: "مرفق",
    t330: "لم أجد معلومات الاتصال ذات الصلة.",
    t331: "لقد قمت بتحويل استفسارك إلى الزميل المسؤول أدناه؛ يمكنك أيضًا النقر على بطاقة العمل للاتصال على الفور.",
    t332: "المعرض",
    t333: "يرجى إدخال",
    t334: "مستخدم",
    t335: "لا يوجد المزيد",
    t336: "تحديث ناجح",
    t337: "جارٍ التحميل",
    t338: "الافراج لتحديث",
  },
};
